:host {
  display: flex;
  align-items: center;

  @include media-max('xl') {
    flex-direction: row-reverse;
  }
}

.dc-ui-header-nav-breadcrumb-item {
  display: flex;
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  padding: 4px 0;
  @include font-style('small-text');
  color: $color-grey-06;
  cursor: pointer;

  &--current {
    cursor: default;
    color: $color-black;
    @include font-style('small-text');

    &:hover {
      color: $color-black !important;
      text-decoration: none !important;
    }
  }

  &:focus-visible {
    outline: 1px solid $color-focus;
    outline-offset: -1px;
  }

  &:hover {
    color: $color-grey-08;
    text-decoration: underline;
  }

  &:active {
    color: $color-black;
  }
}

.separator {
  margin: 0 8px;
  color: $color-grey-03;
}
